import { Paper, Typography, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../components/customInput/CustomInput';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';

type IProps = {
  setting: SettingModel;
  setSetting: (s: SettingModel) => void;
};

function ShippingSetting({ setting, setSetting }: IProps) {
  const t = useTranslate();

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle2'>{t('shippingSetting')}</Typography>

      <FormControlLabel
        control={
          <Switch
            defaultChecked
            checked={setting.IS_ACTIVE_SHIPMONDO}
            color='success'
            onChange={() =>
              setSetting({
                ...setting,
                IS_ACTIVE_SHIPMONDO: !setting.IS_ACTIVE_SHIPMONDO,
              })
            }
          />
        }
        label={t('IS_ACTIVE_SHIPMONDO')}
      />

      {setting.IS_ACTIVE_SHIPMONDO && (
        <>
          <CustomInput
            value={setting?.SHIPMONDO_API_URL || ''}
            onChange={(e) => {
              setSetting({ ...setting, SHIPMONDO_API_URL: e.target.value });
            }}
            label={t('SHIPMONDO_API_URL')}
          />
          <CustomInput
            value={setting?.SHIPMONDO_API_KEY || ''}
            onChange={(e) => {
              setSetting({ ...setting, SHIPMONDO_API_KEY: e.target.value });
            }}
            label={t('SHIPMONDO_API_KEY')}
          />
          <CustomInput
            value={setting?.SHIPMONDO_API_USERNAME || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMONDO_API_USERNAME: e.target.value,
              });
            }}
            label={t('SHIPMONDO_API_USERNAME')}
          />

          <CustomInput
            value={setting?.SHIPPMENT_SENDER_NAME || ''}
            onChange={(e) => {
              setSetting({ ...setting, SHIPPMENT_SENDER_NAME: e.target.value });
            }}
            label={t('SHIPPMENT_SENDER_NAME')}
          />

          <CustomInput
            value={setting?.SHIPMENT_SENDER_ADDRESS || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMENT_SENDER_ADDRESS: e.target.value,
              });
            }}
            label={t('SHIPMENT_SENDER_ADDRESS')}
          />
          <CustomInput
            value={setting?.SHIPMENT_SENDER_CITY || ''}
            onChange={(e) => {
              setSetting({ ...setting, SHIPMENT_SENDER_CITY: e.target.value });
            }}
            label={t('SHIPMENT_SENDER_CITY')}
          />

          <CustomInput
            value={setting?.SHIPMENT_SENDER_COUNTRY || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMENT_SENDER_COUNTRY: e.target.value,
              });
            }}
            label={t('SHIPMENT_SENDER_COUNTRY')}
          />

          <CustomInput
            value={setting?.SHIPMENT_SENDER_POSTAL_CODE || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMENT_SENDER_POSTAL_CODE: e.target.value,
              });
            }}
            label={t('SHIPMENT_SENDER_POSTAL_CODE')}
          />

          <CustomInput
            value={setting?.SHIPMENT_SENDER_MOBILE || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMENT_SENDER_MOBILE: e.target.value,
              });
            }}
            label={t('SHIPMENT_SENDER_MOBILE')}
          />

          <CustomInput
            value={setting?.SHIPMENT_SENDER_EMAIL || ''}
            onChange={(e) => {
              setSetting({
                ...setting,
                SHIPMENT_SENDER_EMAIL: e.target.value,
              });
            }}
            label={t('SHIPMENT_SENDER_EMAIL')}
          />
          <FormControlLabel
            control={
              <Switch
                defaultChecked
                checked={setting.SHIPMENT_TEST}
                color='success'
                onChange={() =>
                  setSetting({
                    ...setting,
                    SHIPMENT_TEST: !setting.SHIPMENT_TEST,
                  })
                }
              />
            }
            label={t('SHIPMONDO_TEST')}
          />

          <FormControlLabel
            control={
              <Switch
                defaultChecked
                checked={setting.ACTIVATE_SHIPMONDO_SHIPMENT_PRICE}
                color='success'
                onChange={() =>
                  setSetting({
                    ...setting,
                    ACTIVATE_SHIPMONDO_SHIPMENT_PRICE:
                      !setting.ACTIVATE_SHIPMONDO_SHIPMENT_PRICE,
                  })
                }
              />
            }
            label={t('ACTIVATE_SHIPMONDO_SHIPMENT_PRICE')}
          />

          <FormControlLabel
            control={
              <Switch
                defaultChecked
                checked={setting.CREATE_SHIPMONDO_SHIPMENT_DIRECTLY}
                color='success'
                onChange={() =>
                  setSetting({
                    ...setting,
                    CREATE_SHIPMONDO_SHIPMENT_DIRECTLY:
                      !setting.CREATE_SHIPMONDO_SHIPMENT_DIRECTLY,
                  })
                }
              />
            }
            label={t('CREATE_SHIPMONDO_SHIPMENT_DIRECTLY')}
          />
        </>
      )}
    </Paper>
  );
}

export default ShippingSetting;
